import CategorySvg from "../../assets/taiga-uikit/icons/category.svg?react";
import LogoutSvg from "../../assets/taiga-uikit/icons/logout-1.svg?react";
import NoteSvg from "../../assets/taiga-uikit/icons/note.svg?react";
import PeopleSvg from "../../assets/taiga-uikit/icons/people.svg?react";
import { _size, _style } from "../../core/core";
import { Button } from "../button/button";
import { FixedPage } from "../FixedPage/FixedPage";
import { Link } from "../link/link";
import "./MobileMenu.css";

interface MobileMenuProps {
    username?: string;
    is_active: boolean;
    set_is_active: (is_active: boolean) => void;
}

export const MobileMenu = ({ is_active, set_is_active }: MobileMenuProps) => {

    const handleLogout = () => {
        set_is_active(false);
    }
    return (

        <FixedPage classNameContainer="menu-fixed" className="mob-menu" is_active={is_active} set_is_active={set_is_active}>
            <div className="mob-menu-main">
                <div className="mob-menu-container" >
                    <Link link={"/uslugi/"} size={_size.M}>Войти в аккаунт</Link>
                    <Button onClick={handleLogout} width={'44px'} size={_size.M} style={_style.outline} icon_left={<LogoutSvg />}></Button>
                </div>
                <div className="mob-menu-content">
                    <div className="mob-menu-content-item">
                        <Link link={"/uslugi/"} style={_style.outline} size={_size.M} icon_left={<CategorySvg />}>Каталог</Link>
                    </div>
                    <div className="mob-menu-content-item">
                        <Link link={"/blog/"} style={_style.outline} size={_size.M} icon_left={<NoteSvg />}>Статьи</Link>
                    </div>
                    <div className="mob-menu-content-item">
                        <Link link={"/blog/"} style={_style.outline} size={_size.M} icon_left={<PeopleSvg />}>Стать исполнителем</Link>
                    </div>
                </div>
            </div>
            <div className="mob-menu-footer">
                <Link style={_style.link} size={_size.M} link={"/blog/oferta/"}>
                    Публичная оферта
                </Link>
                <Link style={_style.link} size={_size.M} link={"/blog/policy/"}>
                    Политика конфиденциальности
                </Link>
            </div>
        </FixedPage>
    );
};